import { render } from "./saveCouponsPayModel.vue?vue&type=template&id=ef82fd80"
import script from "./saveCouponsPayModel.vue?vue&type=script&lang=js"
export * from "./saveCouponsPayModel.vue?vue&type=script&lang=js"

import "./saveCouponsPayModel.vue?vue&type=style&index=0&id=ef82fd80&lang=sass"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__